import Utils from "./utils.class";

const {jQuery: $} = window;

export default class RotatingTabs {

    #theme;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#theme = theme;
        Utils.log("Registered: Rotating Tabs Layout");
    }

    events() {
        const me = this;

        $('.featured_slider__slides').cycle({
            slides: '> .single_slide',
            swipe: true,
            swipeFx: 'scrollHorz',
            fx: 'scrollHorz',
            autoHeight: 'calc',
            easing: 'linear',
            visible: '1',
            log: false,
            pager: '.featured_slider__pagers',
            pagerTemplate: '.single_pager',
            timeout: 0,
            prev: '#prev',
            next: '#next',
        }).on('cycle-after', function (event, optionHash, outgoingSlideEl, incomingSlideEl) {

            // Previous slide tracking (used for some bugfixes)
            $(outgoingSlideEl).parent().find('.single_slide--previous').removeClass('single_slide--previous');
            $(outgoingSlideEl).addClass('single_slide--previous');
        })

        $('.featured_slider .featured_slider__wrap .single_pager__wrap').on('click', function () {
            const num = $(this).attr('data-tab');
            const $parent = $(this).parents('.featured_slider');
            const $tabs = $parent.find('.featured_slider__wrap');
            const $content = $parent.find('.featured_slider__slides');
            const $tab = $(this).parents('.single_pager');

            $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('inactive');

            $tabs.find('.single_pager').removeClass('active').addClass('inactive');
            $tab.addClass('active').removeClass('inactive');
        });

        $('.featured_slider .featured_slider__wrap').each(function (i, el) {
            const $tab = $(el).find('.single_pager:first-child');
            $(el).attr("data-height", $(el).find('.featured_slider__slides').css("max-height"));
        });
    }
}
